
<template>
    <div class="col-12">
        <div class="input-group mb-3">
            <input aria-describedby="basic-addon1" aria-label=""
                   class="form-control col-form-label-lg"
                   name="search" placeholder="Rechercher" type="text" v-model="query" v-on:input="search(false)">
            <div class="input-group-append">
                <button class="btn btn-primary" type="button" v-on:click="search(false)">{{ $t('search') }}
                </button>
              <button class="btn btn-success" type="button" v-on:click="export_csv()"><i class="fas fa-file-excel"></i>
                {{ $t('csv_export') }}
              </button>
            </div>
        </div>
      <small class="form-text text-muted">
        <i v-if="loading" class='fas fa-circle-notch fa-spin'></i> <span
          v-if="!loading">{{
          $t('number_of_result', {
            number: (response['total'] > 0) ? '1 - ' + response['to'] +
                '(total: ' + response['total'] + ')' : '0'
          })
        }}
    </span>
      </small>
        <div class="row mt-5">
            <div class="col-12 col-md-2">
              <h6>{{ $t('estimate_type') }}:</h6>
                <div class="form-check custom-checkbox custom-control" v-for="(badge, index) in equipments">
                    <input class="custom-control-input" type="checkbox" v-bind:checked="!badge['disabled']"
                           :disabled="loading" v-bind:id="'t' + index" v-bind:name="badge['id']"
                           v-on:click="inverseBadge(index, equipments)"/>
                    <label class="custom-control-label" v-bind:for="'t' + index">
                        {{ badge['name'] }}
                    </label>
                </div>
            </div>
            <div class="col-12 col-md-10">
                <div class="table-responsive">
                    <table class="table table-hover" id="receipt">
                        <thead>
                        <tr>
                            <th v-for="(column, index) in columns" v-on:click="sortBy(index)">
                                <span style="cursor: pointer;">{{ column['name'] }}</span>
                                <span v-if="column['orderable']">
                            <i class="fas fa-arrow-down fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === 1}"></i>
                            <i class="fas fa-arrow-up fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === -1}"></i>

                        </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="loading && page === 1">
                          <td colspan="7"><i class="fas fa-circle-notch fa-spin"></i>{{ $t('data_loading') }}
                          </td>
                        </tr>
                        <tr v-if="data.length === 0 && loading === false">
                          <td colspan="7">{{ $t('no_result_found') }}</td>
                        </tr>
                        <tr v-for="(entry, index) in filteredResults" v-if="!loading || page > 1">
                          <th scope="row">{{ entry['created_at'] | moment($t('date_format')) }}</th>
                            <td><span v-for="name in entry['name']">{{ name['value'] }}</span></td>
                            <td><span v-for="postal_code in entry['postal_code']">{{ postal_code['value'] }}</span></td>
                            <td><span v-for="contact in entry['contact']" v-bind:class="entry['processed'] ? 'text-success' : 'text-primary'"><i class="fas fa-thumbs-up fa-3x"></i></span></td>
                            <td><span v-for="email in entry['email']"><a v-bind:href="'mailto:' + email['value']">{{ email['value'] }}</a></span>
                            </td>
                            <td>{{ entry['form'] }}</td>
                            <td>

                                <ul v-if="entry['form'] !== 'devis'">
                                    <li v-for="detail in entry['details']">{{ detail['key']}}: {{ detail['value']}}</li>
                                </ul>
                                <button class="btn btn-sm btn-outline-dark" data-target="#devis_info"
                                        data-toggle="modal" type="button"
                                        v-if="entry['form'] === 'devis'" v-on:click="openDetails(entry, index)">
                                  {{ $t('details') }}
                                </button>

                            </td>
                            <td>
                              <button :disabled="entry['loading']" class="btn" type="button"
                                      v-bind:class="{'btn-success': entry['processed'], 'btn-primary': !entry['processed']}"
                                      v-on:click="processed(entry['id'], index)">
                                <span v-if="entry['processed']">{{ $t('handled') }}  <i class="fas fa-check"></i></span>
                                <span v-if="!entry['processed']">{{ $t('mark_as_handled') }}
                                        <i class="far fa-check-circle"></i></span>
                              </button>
                            </td>
                        </tr>
                        <tr v-if="!loading && data.length !== 0 && response['last_page'] > page">
                          <td id="loadMore" colspan="6" v-on:click="loadMore">{{ $t('load_more') }}</td>
                        </tr>
                        <tr v-if="loading && data.length !== 0 && response['last_page'] > page">
                          <td colspan="6"><i class="fas fa-circle-notch fa-spin"></i> {{ $t('next_results_loading') }}
                          </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div aria-hidden="true" aria-labelledby="Informations sur le devis" class="modal fade" id="devis_info"
             role="dialog" tabindex="-1">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="estimate_selected !== []">
                    <div class="modal-header">
                      <h5 id="exampleModalLabel" class="modal-title">{{ $t('details') }}</h5>
                        <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ul>
                            <li v-for="detail in estimate_selected['details']">{{ detail['key']}}: {{
                                detail['value']}}
                            </li>
                        </ul>
                    </div>
                    <div class="modal-footer">
                      <button class="btn btn-secondary" data-dismiss="modal" type="button">{{ $t('close') }}</button>
                      <button :disabled="estimate_selected['loading']" class="btn" type="button"
                              v-bind:class="{'btn-success': estimate_selected['processed'], 'btn-primary': !estimate_selected['processed']}"
                              v-on:click="processed(estimate_selected['id'], index_selected)">
                        <span v-if="estimate_selected['processed']">{{ $t('handled') }}  <i
                            class="fas fa-check"></i></span>
                        <span v-if="!estimate_selected['processed']">{{ $t('mark_as_handled') }}  <i
                            class="far fa-check-circle"></i></span>
                      </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['equipments_id', 'country'],
        data: function () {
            return {
                sortCell: '',
                loading: true,
                query: '',
                data: [],
                equipments: [],
                supports: [],
                page: 1,
                response: [],
                estimate_selected: [],
                index_selected: 0,
                columns: {
                    'date': {
                      name: this.$i18n.t('date'),
                      db_name: 'created_at',
                      orderable: true,
                      sortDirection: 1,
                      type: 'date'
                    },
                    'name': {
                      name: this.$i18n.t('name'),
                      db_name: 'name',
                      orderable: true,
                      sortDirection: 1,
                      type: 'text'
                    },
                    'postal_code': {
                      name: this.$i18n.t('postal_code'),
                      db_name: 'postal_code',
                      orderable: true,
                      sortDirection: 1,
                      type: 'text'
                    },
                    'contact': {
                      name: this.$i18n.t('contact'),
                      db_name: '',
                      orderable: false,
                      sortDirection: 1,
                      type: 'text'
                    },
                    'email': {
                      name: this.$i18n.t('email'),
                      db_name: 'email',
                      orderable: true,
                      sortDirection: 1,
                      type: 'text'
                    },
                    'form': {
                      name: this.$i18n.t('form'),
                      db_name: 'form',
                      orderable: true,
                      sortDirection: 1,
                      type: 'text'
                    },
                    'details': {
                      name: this.$i18n.t('details'),
                      db_name: '',
                      orderable: false,
                      sortDirection: 1,
                      type: ''
                    },
                    'action': {
                      name: this.$i18n.t('handled'),
                      db_name: 'processed',
                      orderable: true,
                      sortDirection: 1,
                      type: 'text'
                    },
                },
            }
        },
        computed: {
            filteredResults: function () {
                var data = this.data;
                if (this.sortCell) {
                    var cell = this.columns[this.sortCell];
                    var direction = cell['sortDirection'];
                    if (cell['type'] === 'date') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = new Date(a[cell['db_name']]);
                            var b1 = new Date(b[cell['db_name']]);

                            return (a1.getTime() === b1.getTime()) ? 0 : ((a1.getTime() > b1.getTime()) ? 1 : -1) * cell['sortDirection'];
                        });
                    } else if (cell['type'] === 'number') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = a[cell['db_name']];
                            var b1 = b[cell['db_name']];

                            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
                        });
                    } else if (cell['type'] === 'text') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = a[cell['db_name']];
                            var b1 = b[cell['db_name']];

                            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
                        });
                    }
                }
                return data;
            },
        },
        mounted: function () {
            axios.post('estimates/types', {})
                .then(response => {
                    response.data.form_types.forEach(function (item) {
                        var dict = {};
                        dict['name'] = item;
                        if (this.equipments_id.length > 0) {
                            if (this.equipments_id.indexOf(item['id']) < 0) {
                                dict['disabled'] = true;
                            } else {
                                dict['disabled'] = false;
                            }
                        } else {
                            dict['disabled'] = false;
                        }
                        this.equipments.push(dict);
                    }.bind(this));
                    response.data.supports.forEach(function (item) {
                        var dict = {};
                        dict['name'] = item;
                        dict['disabled'] = false;
                        this.supports.push(dict);
                    }.bind(this));
                    this.search();
                });
        },
        created: function () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            openDetails: function (entry, index) {
                this.estimate_selected = entry;
                this.index_selected = index;
            },
            handleScroll: function () {
                if (!this.loading) {
                    if (document.getElementById('loadMore') != null && this.isInViewport(document.getElementById('loadMore'))) {
                        this.loadMore();
                    }
                }
            },
            isInViewport: function (elem) {
                var bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },
            loadMore: function () {
                this.page++;
                this.search(true);
            },
            sortBy: function (index) {
                if (this.columns[index]['orderable'] === true) {
                    this.sortCell = index;
                    this.columns[index]['sortDirection'] *= -1;
                }
            },
            inverseBadge: function (index, arr) {
                arr[index]['disabled'] = !arr[index]['disabled'];
                this.$forceUpdate();
                this.search();
            },
            processed: function (id, index) {
                this.filteredResults[index]['loading'] = true;
                this.$forceUpdate();
                axios
                    .post('estimates/' + id + '/processed', {})
                    .then(response => {
                        this.filteredResults[index]['processed'] = !this.filteredResults[index]['processed'];
                        this.filteredResults[index]['loading'] = false;
                    });
            },
            export_csv: function() {
                var equipments_id = [];
                this.equipments.forEach(function (item) {
                    if (!item['disabled']) {
                        equipments_id.push(item['name']);
                    }
                });
                var supports_id = [];
                this.supports.forEach(function (item) {
                    if (!item['disabled']) {
                        supports_id.push(item['name']);
                    }
                });
                axios
                    .post('estimates/export', {
                        query: this.query,
                        forms: equipments_id,
                        supports: supports_id,
                        country: this.country
                    })
                    .then(response => {
                        if(response.data.status === false) {
                            alert('Une erreur est survenue lors de la génération du fichier CSV. Veuillez réessayer');
                        } else {
                            window.open('/admin/estimates/export');
                        }
                    });

            },
            search: function (next_page = false) {
                this.loading = true;
                if (!next_page) {
                    this.page = 1;
                    this.data = [];
                }
                var equipments_id = [];
                this.equipments.forEach(function (item) {
                    if (!item['disabled']) {
                        equipments_id.push(item['name']);
                    }
                });
                axios
                    .post('estimates/search', {
                        query: this.query,
                        forms: equipments_id,
                        page: this.page,
                        country: this.country
                    })
                    .then(response => {
                        if (next_page) {
                            this.data = this.data.concat(response.data.data);
                        } else {
                            this.data = response.data.data;
                        }
                        this.response = response.data;
                        this.loading = false;
                    });

            },
        }
    }
</script>
